import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import Text from '../../i18n/Text';
import routes from '../../routes';
import ButtonPrimary from '../../components/ButtonPrimary';
import { resetDetails } from '../../store/actions/details';
import { useNavigation } from '../../hooks/useNavigation';
import { useSessionTimeout } from '../../hooks/useSessionTimeout';
import Track from '../../components/Track';
import { bbAnalytics } from '../../helpers/analytics/setup/analytics.service.handler';
import { useConfig } from '../../hooks/Configurator';
import { useText } from '../../hooks/useText';

const CheckInConfirmation = () => {
  const details = useSelector((state) => state.details);
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const { locale } = useSelector((state) => state.i18n);
  const dateFormatter = moment(details.time).locale(locale);

  const atTranslation = useText('CHECKINCONFIRMATION.AT');
  const date = dateFormatter.tz(details.timezone).format(`dddd MMMM Do [${atTranslation}] h:mma`);

  const { CheckInConfirmationPageTimeout } = useConfig(
    ({ bbGeneralOptions }) => bbGeneralOptions.timeouts,
  );

  useSessionTimeout(CheckInConfirmationPageTimeout * 1000, () => {
    bbAnalytics.triggerEventTrack('autoRefresh', null, 'CheckInConfirmation');
    navigation.replace(routes.Splash);
  });

  const next = () => {
    navigation.replace(routes.Splash);
  };

  useEffect(() => {
    bbAnalytics.triggerEventTrack('confirmationPage.confirmation', details.company.name);
    return () => {
      dispatch(resetDetails());
    };
  }, [dispatch, details]);

  return (
    <div className="section">
      <div className="columns is-centered has-text-centered">
        <div className="column is-8">
          <h1 className="title is-2 has-text-success">
            <i className="far fa-check-circle is-h-spaced" />
            <Text>CHECKINCONFIRMATION.HEADING</Text>
          </h1>

          <p className="content is-size-4">
            <span qa-id="service-name">{ details.name || 'service'}</span>
            <br />
            <span qa-id="date">{date}</span>
          </p>

          <p className="content is-size-5">
            <Text>CHECKINCONFIRMATION.HELP</Text>
          </p>


          <Track name="confirmationPage.nextCustomerButton">
            <ButtonPrimary className="is-large" onClick={next} qaId="next-customer-button">
              <Text>CHECKINCONFIRMATION.NEXT</Text>
            </ButtonPrimary>
          </Track>
        </div>
      </div>
    </div>

  );
};

export default CheckInConfirmation;
